enum QueryKeys {
  GetPosts = 'get-posts',
}

export default QueryKeys
